module.exports = __webpack_public_path__ + "static/media/advertising-autoparams.d24be113.png";